module.exports = __webpack_public_path__ + "static/media/amex.21b17cf9.png";